export const ID_REF = "refs/ID_REF";
export const NETWORK_REF = "refs/NETWORK_REF";
export const INCOME_REF = "refs/INCOME_REF";
export const SOCIOECONOMIC_REF = "refs/SOCIOECONOMIC_REF";
export const COMPANY_REF = "refs/COMPANY_REF";
export const RISK_REF = "refs/RISK_REF";
export const RESTRICTIONS_REF = "refs/RESTRICTIONS_REF";